import { constants } from '../constants';

export const ARTICLE_SCHEMA_PATHS = [
  '/ecommerce-integrations/',
  '/features/',
  '/marketing-resources/',
];

export const ArticleSchema = ({
  dateModified = '',
  datePublished = '',
  description = '',
  disambiguatingDescription = '',
  headline = '',
  image = '',
  url = '',
}) => (
  <script type="application/ld+json">
    {JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...(url && { url }),
      ...(headline && { headline }),
      ...(description && { description }),
      ...(disambiguatingDescription && { disambiguatingDescription }),
      ...(image && { image }),
      ...(datePublished && { datePublished }),
      ...(dateModified && { dateModified }),
      author: {
        '@type': 'Organization',
        name: constants.legalName,
        url: constants.url,
      },
      publisher: {
        '@type': 'Organization',
        name: constants.brand,
        url: constants.url,
        logo: {
          '@type': 'ImageObject',
          url: constants.logo,
          contentUrl: constants.logo,
          caption: constants.brand,
        },
      },
    })}
  </script>
);
